export interface SocketDefinition {
  event: string;
  namespace: string;
  methodName: string;
}
